import { render, staticRenderFns } from "./CarrouselTips.vue?vue&type=template&id=07e014c6&"
import script from "./CarrouselTips.vue?vue&type=script&lang=js&"
export * from "./CarrouselTips.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports